<div
  class="char-container ion-activatable"
  [ngClass]="{ masked: isMasked && !isInvalid, filled: char && !isMasked, invalid: isInvalid }"
>
  <p class="char-code" *ngIf="char && !isMasked">{{ char }}</p>
  <ion-icon class="asterisk" *ngIf="char && isMasked" src="assets/images/star.svg"></ion-icon>

  <div class="background"></div>
</div>
